import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/gth2021.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/nngth2021/2ahUKEwithq2lrdjtAhWC2eAKHcjZDrcQ_AUoAnoECBEQBA&biw',
    name: 'gth2021',
    component: () => import(/* webpackChunkName: "about" */ '../views/gth2021.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
